import React from "react";
import flage from "../../components/assets/images/india.png"

const Head = () => {
  return (
    <>
      <section className='head'>
        <div className='container d_flex'>
          <div className='left row'>
            <i className='fa fa-phone'></i>
            <label> +91 8630666722</label>
            <i className='fa fa-envelope'></i>
            <label>flipzonindia@gmail.com</label>
          </div>
          <div className='right row RText'>
            <label>Theme FAQ"s</label>
            <label>Need Help?</label>
            <span><img className="indiaflage" src={flage} alt="" /></span>
            <label>EN</label>
            <span><img className="indiaflage" src={flage} alt="" /></span>
            <label>india</label>
          </div>
        </div>
      </section>
    </>
  )
}

export default Head
